import { defineComponent as n, openBlock as r, createBlock as l, unref as p, mergeProps as v, withCtx as m, createElementVNode as t } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const s = /* @__PURE__ */ n({
  name: "IconAlert",
  __name: "IconAlert",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const o = a;
    return (d, e) => (r(), l(p(c), v(o, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        t("path", { d: "M11.25 10.5v-4a.75.75 0 0 1 1.5 0v4a.75.75 0 0 1-1.5 0M12 14.3a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8" }, null, -1),
        t("path", {
          "fill-rule": "evenodd",
          d: "M21.75 5.5v9a3.25 3.25 0 0 1-3.25 3.25h-6.237L7.47 21.586A.75.75 0 0 1 6.25 21v-3.25H5.5a3.25 3.25 0 0 1-3.25-3.25v-9A3.25 3.25 0 0 1 5.5 2.25h13a3.25 3.25 0 0 1 3.25 3.25m-1.5 9v-9a1.75 1.75 0 0 0-1.75-1.75h-13A1.75 1.75 0 0 0 3.75 5.5v9a1.75 1.75 0 0 0 1.75 1.75h1a1.25 1.25 0 0 1 1.25 1.25v1.94l3.645-2.916a1.25 1.25 0 0 1 .78-.274H18.5a1.75 1.75 0 0 0 1.75-1.75",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  s as default
};
